<template>
    <div>
        <Headers :title="title" />
        <div class="day">{{this.day}}</div>
        <van-steps direction="vertical" >
            <van-step v-for="(item,index) in scheduleList" :key="index">
                <h3>{{item.time}}</h3>
                <p>{{item.data[0].title}}</p>
            </van-step>
        </van-steps>
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import api from "@/api";
export default {
    data(){
        return{
            scheduleList: [],
            day: '',
            title: ''
        }
    },
    created() {
        this.getschedule()
    },
    methods: {
        getschedule() {
            api.schedule({ hall_id: 1, exhibition_id: 25 }).then((res) => {
                console.log(res);
                // let arr1 = [];
                // res.data.map((item) => {
                //     arr1.push(item);
                // });
                // let arr2 = [];
                // arr1.map((item) => {
                //     arr2.push(item.data);
                // });
                // let arr3 = [];
                // arr2.map((item) => {
                //     item.map((value) => {
                //         arr3.push(value);
                //     });
                // });
            
                this.scheduleList = res.data[0].data[0].data;
                this.day = res.data[0].data[0].date
                // this.scheduleList = res.data[1].dat
                // console.log(res.data[0].date[0].date, this.scheduleList)
            });
        },
    },
    components: {
        Headers
    },
}
</script>

<style lang="scss" scoped>
/deep/ .van-steps{
    background: unset;
}
/deep/ .van-step__title--active{
    color: none !important
}
.day{
    font-size: 16px;
    color: #666666;
    line-height: .34rem;
    margin: .28rem 0 .16rem .3rem;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/schedule/index.vue